/** Shared shell for instruction cards in the tab and the acknowledgement modal (readable contrast). */
export const instructionItemShellClassName =
  "rounded-md border border-gray-300 bg-white p-3 text-sm dark:border-slate-500 dark:bg-slate-700";
